import { render, staticRenderFns } from "./WaterModelingSettings.vue?vue&type=template&id=05547c60&"
import script from "./WaterModelingSettings.vue?vue&type=script&lang=js&"
export * from "./WaterModelingSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports